import { useEffect, useState } from "react";
import { CloseCellModal } from "./closeCellModal";

interface CloseCellRequestDetail {
  order_number: string;
  machine_id?: number;
  cell_id?: number;
  message?: string;
}

/**
 * Глобальный компонент для управления показом модалки с просьбой закрыть ячейку
 * Слушает команды от бэкенда через WebSocket и показывает модалку по команде
 */
export function CloseCellModalManager() {
  const [pendingRequest, setPendingRequest] = useState<CloseCellRequestDetail | null>(null);

  useEffect(() => {
    // Слушаем события close_cell_request от WebSocket клиента
    const handleCloseCellRequest = (event: CustomEvent<CloseCellRequestDetail>) => {
      const detail = event.detail;
      setPendingRequest(detail);
    };

    window.addEventListener("close_cell_request", handleCloseCellRequest as EventListener);

    return () => {
      window.removeEventListener("close_cell_request", handleCloseCellRequest as EventListener);
    };
  }, []);

  const handleClose = () => {
    setPendingRequest(null);
  };

  if (!pendingRequest) {
    return null;
  }

  return (
    <CloseCellModal
      orderNumber={pendingRequest.order_number}
      message={pendingRequest.message ?? undefined}
      isOpen={true}
      onClose={handleClose}
    />
  );
}
